let autoPlayInterval;

const carouselSection = document.querySelector('.collection-carousel-section');
if (carouselSection) {
  const nextButton = carouselSection.querySelector('.swiper-button-next');
  
  if (nextButton) {
    autoPlayInterval = setInterval(() => {
      nextButton.click();
    }, 3000);
    
    // hover
    carouselSection.addEventListener('mouseenter', () => {
      clearInterval(autoPlayInterval);
    });
    
    carouselSection.addEventListener('mouseleave', () => {
      autoPlayInterval = setInterval(() => {
        nextButton.click();
      }, 3000);
    });
  }
}


/*
click auslösen
*/
document.querySelectorAll('.swiper-wrapper .swiper-slide').forEach(function (slide) {
  slide.addEventListener('click', function () {
    var target = slide.getAttribute('data-target');
    if (target) {
      window.location.href = target;
    }
  });
});

/* =========================================================
   Schwebender "Zurück"-Button (history back)
   Erstellt den Button automatisch und hängt ihn an <body>.
   Fallback: Startseite, falls kein Browser-Verlauf existiert.
   ========================================================= */

(function () {
  "use strict";

  // Fallback-Ziel, falls kein Verlauf vorhanden ist (z. B. Direkteinstieg)
  var FALLBACK_URL = "/";

  function initBackButton() {
    // Doppelte Initialisierung verhindern
    if (document.querySelector(".rws-back-button")) {
      return;
    }

    var btn = document.createElement("button");
    btn.type = "button";
    btn.className = "rws-back-button";
    btn.setAttribute("aria-label", "Zurück zur vorherigen Seite");
    btn.title = "Zurück";

    // Pfeil-nach-links Icon (inline SVG, erbt currentColor)
    btn.innerHTML =
      '<svg viewBox="0 0 24 24" fill="none" ' +
      'stroke="currentColor" stroke-width="2.2" ' +
      'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
      '<line x1="19" y1="12" x2="5" y2="12"></line>' +
      '<polyline points="12 19 5 12 12 5"></polyline>' +
      "</svg>";

    btn.addEventListener("click", function () {
      // Wenn es einen Verlauf gibt, normal zurück
      if (window.history.length > 1) {
        window.history.back();
      } else {
        // Sonst auf die Startseite (kein Sprung ins Leere)
        window.location.href = FALLBACK_URL;
      }
    });

    document.body.appendChild(btn);
  }

  // Sicherstellen, dass der DOM bereit ist
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initBackButton);
  } else {
    initBackButton();
  }
})();